// extracted by mini-css-extract-plugin
export default {"wrapper":"council_wrapper__8vU-C","inside":"council_inside__BSHTX","links":"council_links__Wict6"};